import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import StatsBar from "./components/StatsBar";
import AboutSection from "./components/AboutSection";
import ProductsSection from "./components/ProductsSection";
import GallerySection from "./components/GallerySection";
import ShippingSection from "./components/ShippingSection";
import BenefitsSection from "./components/BenefitsSection";
import CostelaoGuideSection from "./components/CostelaoGuideSection";
import CustomersSection from "./components/CustomersSection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import QualifyChatbot from "./components/QualifyChatbot";
import AdminPage from "./pages/AdminPage";

const Home = () => {
  return (
    <div className="min-h-screen bg-stone-900">
      <Header />
      <main>
        <HeroSection />
        <StatsBar />
        <AboutSection />
        <ProductsSection />
        <GallerySection />
        <ShippingSection />
        <BenefitsSection />
        <CostelaoGuideSection />
        <CustomersSection />
        <TestimonialsSection />
        <ContactSection />
        <Footer />
      </main>
      <QualifyChatbot />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
